import { movies, typeLabels, type Movie, type MovieType } from '@/mocks/movies';

export function getMovieById(id?: string): Movie | undefined {
  if (!id) return undefined;
  return movies.find((item) => item.id === id);
}

export function getRelatedMovies(movie: Movie, limit = 6): Movie[] {
  const sameType = movies.filter((item) => item.id !== movie.id && item.type === movie.type);
  const sameGenre = movies.filter(
    (item) =>
      item.id !== movie.id &&
      item.type !== movie.type &&
      item.genres.some((genre) => movie.genres.includes(genre)),
  );
  const rest = movies.filter(
    (item) => item.id !== movie.id && !sameType.includes(item) && !sameGenre.includes(item),
  );
  return [...sameType, ...sameGenre, ...rest].slice(0, limit);
}

export function searchMovies(keyword: string): Movie[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return movies
    .filter((item) => {
      const haystack = [
        item.title,
        item.director,
        ...item.cast,
        ...item.genres,
        item.region,
        typeLabels[item.type],
      ]
        .join(' ')
        .toLowerCase();
      return haystack.includes(q);
    })
    .sort((a, b) => b.rating - a.rating);
}

export function filterAndSortMovies(options: {
  type?: MovieType;
  region?: string;
  year?: string | number;
  minRating?: number;
  sort?: string;
}): Movie[] {
  const { type, region = '全部', year = '全部', minRating = 0, sort = 'new' } = options;

  const list = movies.filter((item) => {
    if (type && item.type !== type) return false;
    if (region !== '全部' && item.region !== region) return false;
    if (year !== '全部' && item.year !== Number(year)) return false;
    if (item.rating < minRating) return false;
    return true;
  });

  return [...list].sort((a, b) => {
    if (sort === 'hot') return b.popularity - a.popularity;
    if (sort === 'rating') return b.rating - a.rating;
    return b.updatedAt.localeCompare(a.updatedAt);
  });
}

export const PAGE_SIZE = 9;